<template>
  <div>
    <CRow>
      <CCol lg="26">
         <CTableWrapperEmit :items="getMessagesData()"> 
          <template #header>
            <CIcon name="cil-grid"/>Messages envoyés 
            <div class="card-header-actions">
               <CIcon name="cil-cloud-download"/>
              <a 
                :href="getAPI()+'/api1/messages?convpayload=yes&format=csv&direction=MT'"
                class="card-header-action" 
                rel="noreferrer noopener" 
                target="_blank">
              Messages export (.csv)
              </a>
            </div>
          </template>
        </CTableWrapperEmit>
      </CCol>
    </CRow>
  </div>
</template>

<script>

//require('dotenv').config()
const APIURL = process.env.VUE_APP_API_URL

import CTableWrapperEmit from './SNemit.vue'
import axios from 'axios'

export default {
  name: 'SNEmits',
  data() {
    return { 
      loading: true,
      info: []
    }
  },  
  components: { 
          CTableWrapperEmit
  },
  mounted() {
      var addId=""
 
      // single message?
      if (this.$route.query.id != null)
          addId = "&id="+this.$route.query.id

      // some time the filter is not uptodate => this add the same delay that the header page => ugly but works
      {
        
          axios.get( APIURL+'/api1/devices', {   
            mode: 'no-cors',
                  headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
              withCredentials: false 
            }
            )
            .then(  res => { 
             ; //   console.log('finally imei ='+res)
            }  )
            .catch( err => console.log(err))
            .finally(() => {
               //   console.log('SN messages mounted() imei='+this.$store.state.filterDevicesIMEI)
                  var addIMEI="",addDateFrom="",addDateTo=""
                  if (addId.length<=0)
                  {
                      addIMEI='&imei='+this.$store.state.filterDevicesIMEI
                     // console.log('finally imei store='+this.$store.state.filterDevicesIMEI)
                      var d=this.$store.state.filterDateStart
                      addDateFrom='&dateFrom='+(d.getFullYear())+'-'+(d.getMonth()+1)+'-'+(d.getDate())
                      d=this.$store.state.filterDateEnd
                      addDateTo='&dateTo='+(d.getFullYear())+'-'+(d.getMonth()+1)+'-'+(d.getDate())
                  }
                  
                                  
                  axios.get( APIURL+'/api1/messages?direction=MT'+addId+addDateFrom+addDateTo+addIMEI, {   
                    mode: 'no-cors',
                          headers: {
                          Accept: 'application/json',
                          'Content-Type': 'application/json',
                        },
                      withCredentials: false
                    } )
                    .then( res => {
                          this.info = res.data
                          for(var i=0; i< this.info.length; i++)
                          {
                         //   console.log(this.info[i])
                            this.info[i].time = this.$SNFormatDate( this.info[i].time )
                            for (var x=0; x< this.$store.state.filterDevices.length;x++)
                            {
                              if (this.$store.state.filterDevicesIMEI[x]==this.info[i].imei)
                                  this.info[i].serial=this.$store.state.filterDevices[x]
                            }
                          }
                        }
                      )
                    .catch( err => console.log(err))
                    .finally(() => this.loading = false) 
            }
            )
      }
  },
  methods: {
    getAPI()
    {
        return(APIURL)
    },
    getMessagesData() {
      return this.info;
    }
  }
}

</script>
